var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.info.show,
      "modal-append-to-body": false,
      "width": "640px",
      "top": "8vh",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeDialog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('span', [_vm._v(_vm._s(_vm.$t('anywhereSetting.setting')))]), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.operationStatus,
            expression: "operationStatus"
          }],
          class: ['operation-status', _vm.operationStatus]
        }, [_c('i', {
          class: _vm.operationStatus == 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close'
        }), _c('span', [_vm._v(_vm._s(_vm.operationMessage))])])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "topContent"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "headLeft"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("kioskHost.sourceType")) + ":")]), _c('span', {
    staticClass: "sourceContent"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.tvuAnywhere")))])]), _c('div', {
    staticClass: "headRight"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.pid")) + ":")]), _c('span', {
    staticClass: "pidContent"
  }, [_vm._v(_vm._s(_vm.peerId))])])]), _c('div', {
    staticClass: "videoBox"
  }, [_c('div', {
    staticClass: "location"
  }, [_c('i', {
    staticClass: "el-icon-location-outline",
    staticStyle: {
      "font-size": "18px"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.location))])]), _vm.isSupportGimbal == '1' ? _c('div', {
    staticClass: "gimBalBox"
  }, [_c('div', {
    staticClass: "ringContent"
  }, [_c('img', {
    staticClass: "up",
    style: {
      opacity: _vm.isTopPressed ? '0.6' : '1'
    },
    attrs: {
      "src": require("@/assets/img/up.svg")
    },
    on: {
      "mousedown": function ($event) {
        return _vm.handleMousedown(0);
      },
      "mouseup": _vm.handleMouseup,
      "mouseleave": _vm.handleMouseLeave
    }
  }), _c('img', {
    staticClass: "down",
    style: {
      opacity: _vm.isBottomPressed ? '0.6' : '1'
    },
    attrs: {
      "src": require("@/assets/img/down.svg")
    },
    on: {
      "mousedown": function ($event) {
        return _vm.handleMousedown(1);
      },
      "mouseup": _vm.handleMouseup,
      "mouseleave": _vm.handleMouseLeave
    }
  }), _c('img', {
    staticClass: "left",
    style: {
      opacity: _vm.isLeftPressed ? '0.6' : '1'
    },
    attrs: {
      "src": require("@/assets/img/left.svg")
    },
    on: {
      "mousedown": function ($event) {
        return _vm.handleMousedown(2);
      },
      "mouseup": _vm.handleMouseup,
      "mouseleave": _vm.handleMouseLeave
    }
  }), _c('img', {
    staticClass: "right",
    style: {
      opacity: _vm.isRightPressed ? '0.6' : '1'
    },
    attrs: {
      "src": require("@/assets/img/right.svg")
    },
    on: {
      "mousedown": function ($event) {
        return _vm.handleMousedown(3);
      },
      "mouseup": _vm.handleMouseup,
      "mouseleave": _vm.handleMouseLeave
    }
  }), _c('img', {
    staticClass: "center",
    style: {
      opacity: _vm.isCenterPressed ? '0.6' : '1'
    },
    attrs: {
      "src": require("@/assets/img/reset.svg")
    },
    on: {
      "click": _vm.resetGimBal
    }
  }), _c('img', {
    staticClass: "ring",
    attrs: {
      "src": require("@/assets/img/ring.svg")
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "video"
  }, [_c('NewAttendUser', {
    ref: "attendUser",
    attrs: {
      "singChannel": _vm.singChannel,
      "degreeHost": _vm.degreeHost,
      "userInfo": _vm.userInfo,
      "rtc": _vm.rtc,
      "anywhereSetting": true
    }
  })], 1), _c('div', {
    staticClass: "volume"
  }, [_c('canvas', {
    staticClass: "volumeLeft"
  }), _c('canvas', {
    staticClass: "volumeRight"
  }), _c('img', {
    attrs: {
      "src": require('@/assets/img/volume.svg')
    }
  })])])]), _c('div', {
    staticClass: "scrollableContent"
  }, [_c('div', {
    staticClass: "centerContent"
  }, [_c('div', {
    staticClass: "operation"
  }, [_c('div', {
    staticClass: "resolutionBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("commonSetting.resolution")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "disabled": _vm.isDisabled('resolution') || _vm.isDisabled('resolutionOptions'),
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('resolutionFps', _vm.resolution);
      }
    },
    model: {
      value: _vm.resolution,
      callback: function ($$v) {
        _vm.resolution = $$v;
      },
      expression: "resolution"
    }
  }, _vm._l(_vm.computedResolutionOptions, function (item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.label,
        "disabled": item.disabled
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "framesRateBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.framesRate")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "disabled": _vm.isDisabled('fps') || _vm.isDisabled('fpsOptions'),
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('resolutionFps');
      }
    },
    model: {
      value: _vm.fps,
      callback: function ($$v) {
        _vm.fps = $$v;
      },
      expression: "fps"
    }
  }, _vm._l(_vm.computedFpsOptions, function (item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.label,
        "disabled": item.disabled
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "switchCameraBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.switchCamera")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select",
      "disabled": _vm.isDisabled('cameraPosition')
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('switchCamera');
      }
    },
    model: {
      value: _vm.cameraPosition,
      callback: function ($$v) {
        _vm.cameraPosition = $$v;
      },
      expression: "cameraPosition"
    }
  }, _vm._l(_vm.computedCameraOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "defaultViewBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.defaultView")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "disabled": _vm.isDisabled('defaultView'),
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('defaultView');
      }
    },
    model: {
      value: _vm.defaultView,
      callback: function ($$v) {
        _vm.defaultView = $$v;
      },
      expression: "defaultView"
    }
  }, _vm._l(_vm.defaultViewOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1)], 1)]), _c('div', {
    staticClass: "zoomContent"
  }, [_c('span', {
    staticClass: "zoomText"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.zoomText")))]), _c('div', {
    staticClass: "sliderContent"
  }, [_c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "step": 0.1,
      "min": _vm.anyWhereSetObj.zoomRange && Number(JSON.parse(_vm.anyWhereSetObj.zoomRange).zoomMin),
      "max": _vm.anyWhereSetObj.zoomRange && Number(JSON.parse(_vm.anyWhereSetObj.zoomRange).zoomMax),
      "disabled": _vm.isDisabled('zoom') || _vm.isDisabled('zoomRange')
    },
    on: {
      "change": _vm.changeZoomInputValue
    },
    model: {
      value: _vm.zoom,
      callback: function ($$v) {
        _vm.zoom = $$v;
      },
      expression: "zoom"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false,
      "disabled": _vm.isDisabled('zoom') || _vm.isDisabled('zoomRange')
    },
    on: {
      "change": _vm.changeZoomInputValue,
      "input": function ($event) {
        _vm.zoom = Number(_vm.zoom);
      }
    },
    model: {
      value: _vm.inputZoom,
      callback: function ($$v) {
        _vm.inputZoom = $$v;
      },
      expression: "inputZoom"
    }
  }), _c('el-tooltip', {
    staticClass: "item",
    staticStyle: {
      "padding-left": "5px",
      "cursor": "pointer"
    },
    attrs: {
      "effect": "dark",
      "content": _vm.$t('anywhereSetting.reset'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh-left",
    on: {
      "click": function ($event) {
        return _vm.changeZoomInputValue(1, true);
      }
    }
  })])], 1)]), _c('div', {
    staticClass: "autoWhiteBalance"
  }, [_c('div', {
    staticClass: "autoWhiteBalanceTitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.autoWhiteBalance")))])]), _c('el-switch', {
    attrs: {
      "active-value": '1',
      "inactive-value": '0',
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F",
      "disabled": _vm.isDisabled('whiteBalanceAuto')
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('whiteBalanceAuto');
      }
    },
    model: {
      value: _vm.whiteBalanceAuto,
      callback: function ($$v) {
        _vm.whiteBalanceAuto = $$v;
      },
      expression: "whiteBalanceAuto"
    }
  })], 1), _vm.whiteBalanceAuto == '0' ? _c('div', {
    staticClass: "whiteBalanceContent"
  }, [_c('div', {
    staticClass: "whiteBalance"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.balance")) + ":")]), _c('div', {
    staticClass: "whiteBalanceContent"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.scenes")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "disabled": _vm.isDisabled('whiteBalanceRange'),
      "placeholder": "select"
    },
    on: {
      "change": _vm.changeWhiteBalanceAuto
    },
    model: {
      value: _vm.whiteBalanceType,
      callback: function ($$v) {
        _vm.whiteBalanceType = $$v;
      },
      expression: "whiteBalanceType"
    }
  }, [_c('div', {
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }, [_c('span', {
    staticStyle: {
      "padding": "2px",
      "line-height": "33px",
      "font-size": "18px",
      "color": "#33ab4f"
    }
  }, [_c('i', {
    class: _vm.getIconClass(_vm.whiteBalanceType),
    style: {
      'font-size': '20px'
    }
  })])]), _vm._l(_vm.whiteBalanceOptions, function (item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.label,
        "disabled": item.label == 'Manual' && JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tempMax == 0 && JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tempMin == 0 && JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tintMax == 0 && JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tintMin == 0
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      staticStyle: {
        "padding-right": "5px"
      }
    }, [_c('i', {
      class: _vm.getIconClass(item.label),
      staticStyle: {
        "font-size": "20px"
      }
    })]), _c('span', [_vm._v(_vm._s(item.label))])])]);
  })], 2), _c('el-tooltip', {
    staticClass: "item",
    staticStyle: {
      "width": "20%",
      "padding-left": "4px"
    },
    attrs: {
      "effect": "dark",
      "content": _vm.$t('anywhereSetting.scenesTips'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  })])], 1)]), _c('div', {
    staticClass: "colorControl"
  }, [_c('div', {
    staticClass: "colorTemperature"
  }, [_c('span', {
    staticClass: "temeperature"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.temperature")))]), _c('div', {
    staticClass: "sliderContent"
  }, [_c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "min": _vm.anyWhereSetObj.whiteBalanceRange && Number(JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tempMin),
      "max": _vm.anyWhereSetObj.whiteBalanceRange && Number(JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tempMax),
      "disabled": _vm.platForm == '11' || _vm.isDisabled('whiteBalanceRange')
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.temperature, 'temperature');
      }
    },
    model: {
      value: _vm.temperature,
      callback: function ($$v) {
        _vm.temperature = $$v;
      },
      expression: "temperature"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false,
      "disabled": _vm.platForm == '11' || _vm.isDisabled('whiteBalanceRange')
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.inputTemperature, 'temperature');
      },
      "input": function ($event) {
        _vm.temperature = Number(_vm.temperature);
      }
    },
    model: {
      value: _vm.inputTemperature,
      callback: function ($$v) {
        _vm.inputTemperature = $$v;
      },
      expression: "inputTemperature"
    }
  })], 1)]), _c('div', {
    staticClass: "colorTints"
  }, [_c('span', {
    staticClass: "tints"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.tints")))]), _c('div', {
    staticClass: "sliderContent"
  }, [_c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "min": _vm.anyWhereSetObj.whiteBalanceRange && Number(JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tintMin),
      "max": _vm.anyWhereSetObj.whiteBalanceRange && Number(JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tintMax),
      "disabled": _vm.platForm == '11' || _vm.isDisabled('whiteBalanceRange')
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.tints, 'tint');
      }
    },
    model: {
      value: _vm.tints,
      callback: function ($$v) {
        _vm.tints = $$v;
      },
      expression: "tints"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false,
      "disabled": _vm.platForm == '11' || _vm.isDisabled('whiteBalanceRange')
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.inputTints, 'tint');
      },
      "input": function ($event) {
        _vm.tints = Number(_vm.tints);
      }
    },
    model: {
      value: _vm.inputTints,
      callback: function ($$v) {
        _vm.inputTints = $$v;
      },
      expression: "inputTints"
    }
  })], 1)])])]) : _vm._e()]), _c('div', {
    staticClass: "bottomContent"
  }, [_c('div', {
    staticClass: "lockApp"
  }, [_c('div', {
    staticClass: "lockAppTitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.lockApp")))]), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('anywhereSetting.lockAppTips'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  })])], 1), _c('el-switch', {
    attrs: {
      "active-value": '1',
      "inactive-value": '0',
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F",
      "disabled": _vm.isDisabled('lock')
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('lockScreen');
      }
    },
    model: {
      value: _vm.locked,
      callback: function ($$v) {
        _vm.locked = $$v;
      },
      expression: "locked"
    }
  })], 1), _c('div', {
    staticClass: "autoFocus"
  }, [_c('div', {
    staticClass: "autoFocusSwitch"
  }, [_c('div', {
    staticClass: "autoFocusTitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.autoFocus")))])]), _c('el-switch', {
    attrs: {
      "active-value": '1',
      "inactive-value": '0',
      "active-color": "#33AB4F",
      "disabled": _vm.isDisabled('autoFocus') || Number(JSON.parse(_vm.anyWhereSetObj.focusDistanceRange).focusMax) == 0,
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('autoFocus');
      }
    },
    model: {
      value: _vm.autoFocus,
      callback: function ($$v) {
        _vm.autoFocus = $$v;
      },
      expression: "autoFocus"
    }
  })], 1), _vm.autoFocus == '0' ? _c('div', {
    staticClass: "autoFocusValue"
  }, [_c('span', {
    staticClass: "focus"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.focusValue")))]), _c('div', {
    staticClass: "sliderContent"
  }, [_c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "step": 0.01,
      "min": _vm.anyWhereSetObj.focusDistanceRange && Number(JSON.parse(_vm.anyWhereSetObj.focusDistanceRange).focusMin),
      "max": _vm.anyWhereSetObj.focusDistanceRange && Number(JSON.parse(_vm.anyWhereSetObj.focusDistanceRange).focusMax),
      "disabled": _vm.isDisabled('focusDistanceRange') || _vm.isDisabled('focusDistance') || Number(JSON.parse(_vm.anyWhereSetObj.focusDistanceRange).focusMax) == 0
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.focus, 'focus');
      }
    },
    model: {
      value: _vm.focus,
      callback: function ($$v) {
        _vm.focus = $$v;
      },
      expression: "focus"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "disabled": _vm.isDisabled('focusDistanceRange') || _vm.isDisabled('focusDistance') || Number(JSON.parse(_vm.anyWhereSetObj.focusDistanceRange).focusMax) == 0,
      "show-input-controls": false
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.inputFocus, 'focus');
      },
      "input": function ($event) {
        _vm.focus = Number(_vm.focus);
      }
    },
    model: {
      value: _vm.inputFocus,
      callback: function ($$v) {
        _vm.inputFocus = $$v;
      },
      expression: "inputFocus"
    }
  })], 1)]) : _vm._e()]), _c('div', {
    staticClass: "autoExposure"
  }, [_c('div', {
    staticClass: "autoFocusSwitch"
  }, [_c('div', {
    staticClass: "autoFocusTitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.autoExposure")))])]), _c('el-switch', {
    attrs: {
      "active-value": '1',
      "inactive-value": '0',
      "active-color": "#33AB4F",
      "disabled": _vm.isDisabled('autoExposure') || Number(JSON.parse(_vm.anyWhereSetObj.exposureRange).exposureMax) == 0,
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('autoExposure');
      }
    },
    model: {
      value: _vm.autoExposure,
      callback: function ($$v) {
        _vm.autoExposure = $$v;
      },
      expression: "autoExposure"
    }
  })], 1), _vm.autoExposure == '0' ? _c('div', {
    staticClass: "autoFocusValue"
  }, [_c('span', {
    staticClass: "exposure"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.exposureValue")))]), _c('div', {
    staticClass: "sliderContent"
  }, [_c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "step": 0.01,
      "min": _vm.anyWhereSetObj.exposureRange && Number(JSON.parse(_vm.anyWhereSetObj.exposureRange).exposureMin),
      "max": _vm.anyWhereSetObj.exposureRange && Number(JSON.parse(_vm.anyWhereSetObj.exposureRange).exposureMax),
      "disabled": _vm.isDisabled('exposureRange') || _vm.isDisabled('exposure')
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.exposure, 'exposure');
      }
    },
    model: {
      value: _vm.exposure,
      callback: function ($$v) {
        _vm.exposure = $$v;
      },
      expression: "exposure"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false,
      "disabled": _vm.isDisabled('exposureRange') || _vm.isDisabled('exposure')
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.inputExposure, 'exposure');
      },
      "input": function ($event) {
        _vm.exposure = Number(_vm.exposure);
      }
    },
    model: {
      value: _vm.inputExposure,
      callback: function ($$v) {
        _vm.inputExposure = $$v;
      },
      expression: "inputExposure"
    }
  })], 1)]) : _vm._e()])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };